import {FC, useCallback} from "react";
import {Card} from "@brg/api";
import styled from "styled-components";
import {BookCard} from "./BookCard";
import Masonry from "react-masonry-css";
import {LayoutConst} from "../../../../../../core";
import {useIsMobile} from "@brg/ui";
import {UpsertBookData} from "../../../../../../shared/actions/Book/UpsertBookData";
import {useDispatch} from "react-redux";

const BookCardListWrapper = styled.div`
  .main-page-masonry-grid {
    display: -webkit-box; /* Not needed if autoprefixing */
    display: -ms-flexbox; /* Not needed if autoprefixing */
    display: flex;
    margin-left: -24px; /* gutter size offset */
    width: auto;
  }

  .main-page-masonry-grid_column {
    padding-left: 24px; /* gutter size */
    background-clip: padding-box;
  }

  @media (max-width: ${LayoutConst.screen.l}px) {
    .main-page-masonry-grid_column {
      padding-left: 10px;
    }
    .main-page-masonry-grid {
      margin-left: -10px;
    }
  }
  @media (max-width: ${LayoutConst.screen.s}px) {
    .main-page-masonry-grid_column:nth-child(2) {
      ${p => p ? 'padding-left: 10px' : ''};
    }
  }
`

interface BookCardListProps {
    cards: Card<"Global">[],
    isLoading?: boolean,
    isEditMode?: boolean,
    activeCardIds?: string[],
    setActiveCardIds?: (val: string[]) => void,
    setIsCardsUpdateIsLoading?: (val: boolean) => void,
    bookId?: string
}


export const BookCardList: FC<BookCardListProps> = ({cards,
                                                        activeCardIds,
                                                        setActiveCardIds,
                                                        isLoading, setIsCardsUpdateIsLoading, bookId,
                                                        isEditMode}) => {

    const isMobile = useIsMobile();
    const dispatch = useDispatch()

    const onChange = useCallback((addIds = [], removeIds = []) => {
        UpsertBookData(bookId || "", {addIds: addIds, removeIds: removeIds}, setIsCardsUpdateIsLoading || (() => {}), dispatch)
    }, [])

    const onSelect = useCallback((cardId: string) => {

        if (!setActiveCardIds || activeCardIds === undefined) return;

        if (activeCardIds?.includes(cardId)) {
            setActiveCardIds(activeCardIds?.filter(id => id !== cardId))
            // @ts-ignore
            onChange([], [cardId])
            return;
        }

        setActiveCardIds([...activeCardIds, cardId]);
        // @ts-ignore
        onChange([cardId], [])

    }, [setActiveCardIds, activeCardIds])

    return <BookCardListWrapper><Masonry
        breakpointCols={isMobile ? 2 : 4}
        className="main-page-masonry-grid"
        columnClassName="main-page-masonry-grid_column"
    >
        {cards.map((card, index) =>
            // @ts-ignore
            <BookCard isSelectable={isEditMode} onSelect={onSelect} isActive={activeCardIds?.includes(card?.itemId || '')} card={card} key={index}/>)}
    </Masonry></BookCardListWrapper>
}import {FC, useCallback} from "react";
import {Card} from "@brg/api";
import styled from "styled-components";
import {BookCard} from "./BookCard";
import Masonry from "react-masonry-css";
import {LayoutConst} from "../../../../../../core";
import {useIsMobile} from "@brg/ui";
import {UpsertBookData} from "../../../../../../shared/actions/Book/UpsertBookData";
import {useDispatch} from "react-redux";

const BookCardListWrapper = styled.div`
  .main-page-masonry-grid {
    display: -webkit-box; /* Not needed if autoprefixing */
    display: -ms-flexbox; /* Not needed if autoprefixing */
    display: flex;
    margin-left: -24px; /* gutter size offset */
    width: auto;
  }

  .main-page-masonry-grid_column {
    padding-left: 24px; /* gutter size */
    background-clip: padding-box;
  }

  @media (max-width: ${LayoutConst.screen.l}px) {
    .main-page-masonry-grid_column {
      padding-left: 10px;
    }
    .main-page-masonry-grid {
      margin-left: -10px;
    }
  }
  @media (max-width: ${LayoutConst.screen.s}px) {
    .main-page-masonry-grid_column:nth-child(2) {
      ${p => p ? 'padding-left: 10px' : ''};
    }
  }
`

interface BookCardListProps {
    cards: Card<"Global">[],
    isLoading?: boolean,
    isEditMode?: boolean,
    activeCardIds?: string[],
    setActiveCardIds?: (val: string[]) => void,
    setIsCardsUpdateIsLoading?: (val: boolean) => void,
    bookId?: string
}


export const BookCardList: FC<BookCardListProps> = ({cards,
                                                        activeCardIds,
                                                        setActiveCardIds,
                                                        isLoading, setIsCardsUpdateIsLoading, bookId,
                                                        isEditMode}) => {

    const isMobile = useIsMobile();
    const dispatch = useDispatch()

    const onChange = useCallback((addIds = [], removeIds = []) => {
        UpsertBookData(bookId || "", {addIds: addIds, removeIds: removeIds}, setIsCardsUpdateIsLoading || (() => {}), dispatch)
    }, [])

    const onSelect = useCallback((cardId: string) => {

        if (!setActiveCardIds || activeCardIds === undefined) return;

        if (activeCardIds?.includes(cardId)) {
            setActiveCardIds(activeCardIds?.filter(id => id !== cardId))
            // @ts-ignore
            onChange([], [cardId])
            return;
        }

        setActiveCardIds([...activeCardIds, cardId]);
        // @ts-ignore
        onChange([cardId], [])

    }, [setActiveCardIds, activeCardIds])

    return <BookCardListWrapper><Masonry
        breakpointCols={isMobile ? 2 : 4}
        className="main-page-masonry-grid"
        columnClassName="main-page-masonry-grid_column"
    >
        {cards.map((card, index) =>
            // @ts-ignore
            <BookCard isSelectable={isEditMode} onSelect={onSelect} isActive={activeCardIds?.includes(card?.itemId || '')} card={card} key={index}/>)}
    </Masonry></BookCardListWrapper>
}